import { httpClientOmni } from "@/libraries";

const state = {
  isLoadingSummary: false,
  summaryData: null,
  isLoadingAverage: false,
  averageData: null,
  isLoadingCategoryInsight: false,
  categoryInsightData: null,
  isLoadingTopRating: false,
  topRatingData: null,
  isLoadingRequiresImprovement: false,
  requiresImprovementData: null,
};
const getters = {
  isLoadingSummary(state) {
    return state.isLoadingSummary;
  },
  summaryData(state) {
    return state.summaryData;
  },
  isLoadingAverage(state) {
    return state.isLoadingAverage;
  },
  averageData(state) {
    return state.averageData;
  },
  isLoadingCategoryInsight(state) {
    return state.isLoadingCategoryInsight;
  },
  categoryInsightData(state) {
    return state.categoryInsightData;
  },
  isLoadingTopRating(state) {
    return state.isLoadingTopRating;
  },
  topRatingData(state) {
    return state.topRatingData;
  },
  isLoadingRequiresImprovement(state) {
    return state.isLoadingRequiresImprovement;
  },
  requiresImprovementData(state) {
    return state.requiresImprovementData;
  },
};
const mutations = {
  SET_IS_LOADING_SUMMARY: (state, payload) => {
    state.isLoadingSummary = payload;
  },
  SET_SUMMARY_DATA: (state, payload) => {
    state.summaryData = payload;
  },
  SET_IS_LOADING_AVERAGE: (state, payload) => {
    state.isLoadingAverage = payload;
  },
  SET_AVERAGE_DATA: (state, payload) => {
    state.averageData = payload;
  },
  SET_IS_LOADING_CATEGORY_INSIGHT: (state, payload) => {
    state.isLoadingCategoryInsight = payload;
  },
  SET_CATEGORY_INSIGHT_DATA: (state, payload) => {
    state.categoryInsightData = payload;
  },
  SET_IS_LOADING_TOP_RATING: (state, payload) => {
    state.isLoadingTopRating = payload;
  },
  SET_TOP_RATING_DATA: (state, payload) => {
    state.topRatingData = payload;
  },
  SET_IS_LOADING_REQUIRES_IMPROVEMENT: (state, payload) => {
    state.isLoadingRequiresImprovement = payload;
  },
  SET_TOP_REQUIRES_IMRPOVEMENT_DATA: (state, payload) => {
    state.requiresImprovementData = payload;
  },
  SET_IS_LOADING_OVERVIEW: (state, payload) => {
    state.isLoadingOverview = payload;
  },
  SET_OVERVIEW_DATA: (state, payload) => {
    state.overviewData = payload;
  },
};
const actions = {
  async getSummaryData(context, obj) {
    context.commit("SET_IS_LOADING_SUMMARY", true);

    let response = await httpClientOmni.get(
      `${import.meta.env.VITE_OMNICHANNEL_URL}/api/${
        context.rootGetters.appId.hashed
      }/rating-dashboard/summary`,
      {
        params: {
          start: obj.dateStart,
          end: obj.dateEnd,
          business_unit: obj.business_unit ?? "",
          channel: obj.channel ?? "",
          agent_group: obj.agent_group ?? "",
          type: obj.ratingType ?? "",
          rate_value: obj.ratingValue ?? "",
        },
      }
    );

    context.commit("SET_IS_LOADING_SUMMARY", false);
    context.commit("SET_SUMMARY_DATA", response.data.data);
  },
  async getAverageData(context, obj) {
    context.commit("SET_IS_LOADING_AVERAGE", true);

    let response = await httpClientOmni.get(
      `${import.meta.env.VITE_OMNICHANNEL_URL}/api/${
        context.rootGetters.appId.hashed
      }/rating-dashboard/rating-average`,
      {
        params: {
          start: obj.dateStart,
          end: obj.dateEnd,
          business_unit: obj.business_unit ?? "",
          channel: obj.channel ?? "",
          agent_group: obj.agent_group ?? "",
          type: obj.ratingType ?? "",
          rate_value: obj.ratingValue ?? "",
        },
      }
    );

    context.commit("SET_IS_LOADING_AVERAGE", false);
    context.commit("SET_AVERAGE_DATA", response.data.data);
  },
  async getCategoryInsightData(context, obj) {
    context.commit("SET_IS_LOADING_CATEGORY_INSIGHT", true);

    let response = await httpClientOmni.get(
      `${import.meta.env.VITE_OMNICHANNEL_URL}/api/${
        context.rootGetters.appId.hashed
      }/rating-dashboard/category-insight`,
      {
        params: {
          start: obj.dateStart,
          end: obj.dateEnd,
          business_unit: obj.business_unit ?? "",
          channel: obj.channel ?? "",
          agent_group: obj.agent_group ?? "",
          type: obj.ratingType ?? "",
          rate_value: obj.ratingValue ?? "",
        },
      }
    );

    context.commit("SET_IS_LOADING_CATEGORY_INSIGHT", false);
    context.commit("SET_CATEGORY_INSIGHT_DATA", response.data.data);
  },
  async getTopRatingData(context, obj) {
    context.commit("SET_IS_LOADING_TOP_RATING", true);

    let response = await httpClientOmni.get(
      `${import.meta.env.VITE_OMNICHANNEL_URL}/api/${
        context.rootGetters.appId.hashed
      }/rating-dashboard/top-agent`,
      {
        params: {
          start: obj.dateStart,
          end: obj.dateEnd,
          business_unit: obj.business_unit ?? "",
          channel: obj.channel ?? "",
          agent_group: obj.agent_group ?? "",
          type: obj.ratingType ?? "",
          rate_value: obj.ratingValue ?? "",
        },
      }
    );

    context.commit("SET_IS_LOADING_TOP_RATING", false);
    context.commit("SET_TOP_RATING_DATA", response.data.data);
  },
  async getRequiresImprovementData(context, obj) {
    context.commit("SET_IS_LOADING_REQUIRES_IMPROVEMENT", true);

    let response = await httpClientOmni.get(
      `${import.meta.env.VITE_OMNICHANNEL_URL}/api/${
        context.rootGetters.appId.hashed
      }/rating-dashboard/requires-improvement-agent`,
      {
        params: {
          start: obj.dateStart,
          end: obj.dateEnd,
          business_unit: obj.business_unit ?? "",
          channel: obj.channel ?? "",
          agent_group: obj.agent_group ?? "",
          type: obj.ratingType ?? "",
          rate_value: obj.ratingValue ?? "",
        },
      }
    );

    context.commit("SET_IS_LOADING_REQUIRES_IMPROVEMENT", false);
    context.commit("SET_TOP_REQUIRES_IMRPOVEMENT_DATA", response.data.data);
  },
};
export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
